import React, { Fragment } from "react";
import ReactDom from "react-dom";
import OffersAppRoutes from "./OffersAppRoutes";

import { $ } from "../../js/shared/utils";
import { IS_HMG, IS_PROD, IS_DEV } from "./../../js/shared/constants";

import thunkMiddleware from "redux-thunk";
import promise from "redux-promise";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import reducers from "./reducers";

import { browserHistory } from "react-router";

//import createMemoryHistory from "history/createMemoryHistory";
import { createBrowserHistory } from "history";
import { ConnectedRouter, routerMiddleware } from "react-router-redux";
import SubscribersGa from "./events/ga/subscribersGa";
export const history = createBrowserHistory();
const middleware = routerMiddleware(history);
export let store;

if (IS_DEV || IS_HMG) {
	const composeEnhancers =
		typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
			? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
					// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
			  })
			: compose;

	const enhancer = composeEnhancers(
		applyMiddleware(middleware, thunkMiddleware, promise)
		// other store enhancers if any
	);

	store = createStore(reducers, enhancer);
} else if (IS_PROD) {
	store = createStore(reducers, applyMiddleware(middleware, thunkMiddleware, promise));
}

history.push(window.location.pathname + window.location.search);

if ($("#loader_wrapper")) {
	$("#loader_wrapper").classList.add("visualHidden");

	setTimeout(() => {
		$("#loader_wrapper").classList.add("hidden");
	}, 900);
}

ReactDom.render(
	<Fragment>
		<SubscribersGa />
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<OffersAppRoutes />
			</ConnectedRouter>
		</Provider>
	</Fragment>,
	document.getElementById("root")
);
